import { Box, useTheme } from '@mui/material';
import { Button } from '../../../../shared/components/ui/Button';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Can } from '../../../../shared/components/Permission';

interface ActionButtonsProps {
  onEdit: () => void;
  onDelete: () => void;
  disableDelete?: boolean;
}

export function ActionButtons({ onEdit, onDelete, disableDelete = false }: ActionButtonsProps) {
  const theme = useTheme();
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mb: 2 }}>
      <Can roles={['ADMIN']}>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<EditIcon />}
          sx={{
            fontWeight: 700,
            fontSize: 16,
            borderRadius: 2,
            px: 3,
            py: 1,
            textTransform: 'none',
            bgcolor: theme.palette.mode === 'light' ? '#F0F6FF' : theme.palette.background.paper,
            borderColor: theme.palette.mode === 'light' ? '#B6D4FE' : theme.palette.divider,
            color: theme.palette.text.primary,
            '&:hover': {
              bgcolor: theme.palette.mode === 'light' ? '#E3EDFC' : theme.palette.action.hover,
              borderColor: theme.palette.mode === 'light' ? '#B6D4FE' : theme.palette.divider,
            },
          }}
          onClick={onEdit}
        >
          Editar Evento
        </Button>
        <Button
          variant="outlined"
          color="error"
          startIcon={<DeleteOutlineIcon />}
          sx={{
            fontWeight: 700,
            fontSize: 16,
            borderRadius: 2,
            px: 3,
            py: 1,
            textTransform: 'none',
            bgcolor: theme.palette.mode === 'light' ? '#FFF0F0' : theme.palette.background.paper,
            borderColor: theme.palette.mode === 'light' ? '#F3D1D1' : theme.palette.divider,
            color: theme.palette.error.main,
            '&:hover': {
              bgcolor: theme.palette.mode === 'light' ? '#FFE5E5' : theme.palette.action.hover,
              borderColor: theme.palette.mode === 'light' ? '#F3D1D1' : theme.palette.divider,
            },
          }}
          onClick={onDelete}
          disabled={disableDelete}
        >
          Excluir Evento
        </Button>
      </Can>
    </Box>
  );
}